module.exports = __webpack_public_path__ + "img/Binguo1.15d3085e.jpg";